import { render, staticRenderFns } from "./SBHorizontalScrollItem.html?vue&type=template&id=4bceaefc&scoped=true&"
import script from "./SBHorizontalScrollItem.ts?vue&type=script&lang=ts&"
export * from "./SBHorizontalScrollItem.ts?vue&type=script&lang=ts&"
import style0 from "./SBHorizontalScrollItem.css?vue&type=style&index=0&id=4bceaefc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bceaefc",
  null
  
)

export default component.exports